module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-859-min.63c31e73.jpg";